import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import "./App.css";
import {AppRouter} from './AppRoute'
import { ToastContainer } from "react-toastify";
import { AlertProvider } from "./context/AlertContext";

export default function App() {
  // Theme is managed by ThemeSync inside RootLayout (see AppRoute.jsx)

  return (
    <AlertProvider>
      <RouterProvider router={AppRouter} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </AlertProvider>
  );
}